import React, { useState, useEffect } from "react";
import Table from "../../Common/Table/Table";
import queryString from "query-string";
import "./Spam.scss";
import { useLocation, withRouter, Redirect } from "react-router-dom";
import StatTile from "../../Common/StatsTile/StatTile";
import Spinner from "../../Common/Spinner/Spinner";
import Api from "../../../Api";
import { useParams } from "react-router-dom";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";
import Pagination from "../../Common/Pagination/Pagination";
import BlockedPopup from "../../Common/BlockedPopup/BlockedPopup";
import { connect, useDispatch } from "react-redux";
import "antd/dist/antd.css";
import { DatePicker } from "antd";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/lab/Alert";
import HeaderWithSearch from "../../Common/HeaderWithSearch/HeaderWithSearch";
import ConfirmPopup from "../../Common/ConfirmPopup/ConfirmPopup";
import Button from "../../Common/Button/Button";
// import { send } from '../../WebSocket/WebSocket';
import PDFIcon from "../../../assets/icons/PDFIcon";
import CSVIcon from "../../../assets/icons/CSVIcon";
import XLSIcon from "../../../assets/icons/XLSIcon";
import DraggableDialog from "../../Common/DialogBox/DialogBox";

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

function SpamAnswers({ loading, SpamAnswerList }) {
  const navigate = useNavigate();
  let { status } = useParams();
  const dispatch = useDispatch();
  const [SpamAnswerStatData, setSpamAnswerStatData] = useState();
  const [SpamAnswerDataSource, setSpamAnswerDataSource] = useState();
  // const [name, setName] = useState(status);
  const [limit, setLimit] = useState("");
  const [message, setMessage] = useState("");
  const [severity, setSeverity] = useState("");
  const [openMessage, setOpenMessage] = useState(false);
  const [offset, setOffset] = useState("");
  const today = moment(new Date()).format('YYYY-MM-DD');
    const monthly = moment(today).subtract(5, 'months').format('YYYY-MM-DD');
    const [fromDate, setFromDate] = useState(monthly);
    const [toDate, setToDate] = useState(today);
  const [searchGroup, setSearchGroup] = useState("");
  const [checked, setChecked] = useState(false);
  const [deleteElement, setDeleteElement] = useState([]);
  const [selectAllChecked, setSelectAllChecked] = useState(false);
  const [selectedElements, setSelectedElements] = useState([]);
  const [SpamAnswerPagination, setSpamAnswerPagination] = useState();
  const [openGetError, setOpenGetError] = useState(false);
  const [getErrorMessage, setGetErrorMessage] = useState("");
  const [pageLoading, setPageLoading] = useState(true);
  const [compLoading, setCompLoading] = useState(true);
  const [deactivatePopup, setDeactivatePopup] = useState(false);
  const [blockPopup, setBlockPopup] = useState(false);
  const [deletePopup, setDeletePopup] = useState(false);
  // const [activatePopup, setActivatePopup] = useState(false);
  // const [deletePopup, setDeletePopup] = useState(false);
  const location = useLocation();
  const headerLayout = "40px 40px 4fr 3fr 3fr";
  const columnLayout = "40px 40px 4fr 3fr 3fr";
  const header = [
    // <input type="checkbox" />,
    <div className="checkbox">
      <input
        type="checkbox"
        id="header"
        checked={selectAllChecked}
        onChange={() => {
          setSelectAllChecked(!selectAllChecked);
          !selectAllChecked && SpamAnswerDataSource
            ? setSelectedElements(SpamAnswerDataSource.map((data) => data.id))
            : setSelectedElements([]);
        }}
      />
      <label htmlFor="header" />
    </div>,
    "#",
    "Answer",
    "Reported By",
    "Reported On",
    
  ];
  // console.log(SpamAnswerDataSource)
  useEffect(() => {
    SpamAnswerStatFunction();
    SpamAnswerDataFunction(searchGroup, status, fromDate, toDate, "", "");
  }, [SpamAnswerList.isLoaded]);

  useEffect(() => {
    const parsed = queryString.parse(location.search);
    SpamAnswerDataFunction(
      searchGroup,
      status,
      fromDate,
      toDate,
      parsed.limit,
      parsed.offset
    );
  }, [location, fromDate, toDate]);

  useEffect(() => {
    if (searchGroup === "") {
      const parsed = queryString.parse(location.search);
      SpamAnswerDataFunction(
        searchGroup,
        status,
        fromDate,
        toDate,
        parsed.limit,
        parsed.offset
      );
    }
  }, [searchGroup]);

  const SpamAnswerStatFunction = () => {
    setSpamAnswerStatData({
      active: 0,
    });
  };
  const close = async () => {
    let data = {};
    data["spam_answer_ids"] = selectedElements;
    const response = await Api.closeSpamAnswer(data);
    console.log(response);
    if (response?.status === 200) {
      const newData = SpamAnswerDataSource.filter(
        (item) => !selectedElements.includes(item.id)
      );
      setMessage(`Answer${selectedElements.length > 1 ? "s " : " "}Closed`);
      setSeverity("success");
      setOpenMessage(true);
      dispatch({ type: "SPAM_ANSWER_TOGGLE" });
      // console.log(newData)
      setSelectedElements([]);
    } else {
      setMessage(`Some Error Occured`);
      setSeverity("error");
      setOpenMessage(true);
      setSelectedElements([]);
    }
  };
  const deleteSpam = async () => {
    let data = {};
    data["spam_Answer_ids"] = selectedElements;
    const response = await Api.deleteSpamAnswer(data);
    console.log(response, "reached");
    if (response?.status === 204) {
      const newData = SpamAnswerDataSource.filter(
        (item) => !selectedElements.includes(item.id)
      );
      setMessage(`Answer${selectedElements.length > 1 ? "s " : " "}deleted`);
      setSeverity("success");
      setOpenMessage(true);
      dispatch({ type: "SPAM_ANSWER_TOGGLE" });
      // console.log(newData)
      setSelectedElements([]);
    } else {
      setMessage(`Some Error Occured`);
      setSeverity("error");
      setOpenMessage(true);
      setSelectedElements([]);
    }
  };

  console.log(SpamAnswerList);
  const SpamAnswerDataFunction = async (
    searchGroup,
    status,
    fromDate,
    toDate,
    limit,
    offset
  ) => {
    setSelectedElements([]);
    const apiCall = async () => {
      setCompLoading(true);
      console.log("Called");
      try {
        offset = offset ? offset : 0;
        await Api.getSpamAnswers(
        {  searchGroup,
          status,
          fromDate,
          toDate,
          limit,
          offset}
        ).then((response) => {
          console.log(response);
          setSpamAnswerStatData({
            active: response?.data?.count ? response.data.count : 0,
          });
          setSpamAnswerDataSource(
            response.data?.body?.map(({ answer, pk,created_at ,by}, index) => {
              console.log(answer)
              return {
                no: index + 1,
                id: pk,
                Answer: answer,
                asked_by: by.fullname,
                created_at: created_at,
                current_status: "active",
              };
            })
          );
          setSpamAnswerPagination(response?.data)
          if (!SpamAnswerList.isLoaded && toDate===today && fromDate===monthly )
            dispatch({
              type: "SPAM_ANSWER_LIST",
              payload: { data: response.data, isLoaded: true },
            });
          setPageLoading(false);
          setCompLoading(false);
        });
      } catch (error) {
        setGetErrorMessage(error.response?.data?.detail);
        setOpenGetError(true);
      }
    };
    if (!SpamAnswerList.isLoaded|| fromDate!==monthly || toDate!==today) apiCall();
    else {
      setSpamAnswerStatData({
        active: SpamAnswerList.data?.count ? SpamAnswerList.data.count : 0,
      });
      setSpamAnswerDataSource(
        SpamAnswerList.data?.body?.map(({ answer, pk,created_at ,by}, index) => {
          console.log(answer)
          return {
            no: index + 1,
            id: pk,
            Answer: answer,
            asked_by: by.fullname,
            created_at: created_at,
            current_status: "active",
          };
        })
      );
      setSpamAnswerPagination(SpamAnswerList.data)
      setPageLoading(false);
      setCompLoading(false);
    }
  };

  const paginationData = (data) => {
    var parsed = queryString.parse(data);
    // setLimit(parsed.limit);
    // setOffset(parsed.offset);
    const offset = parsed.offset ? parsed.offset : 0;
    SpamAnswerDataFunction(
      searchGroup,
      status,
      fromDate,
      toDate,
      parsed.limit,
      parsed.offset
    );
    navigate(`/spam-replies/${status}?limit=${parsed.limit}&offset=${offset}`);
  };

  const handleClose = () => {
    setOpenMessage(false);
  };

  const handleCheck = (key) => {
    selectedElements.includes(key)
      ? setSelectedElements(
          selectedElements.filter(function (item) {
            return item !== key;
          })
        )
      : setSelectedElements([...selectedElements, key]);
  };

  useEffect(() => {
    if (selectedElements?.length === SpamAnswerDataSource?.length)
      setSelectAllChecked(true);
    else setSelectAllChecked(false);
  }, [selectedElements]);

  const colorMap = {
    closed: "#FF5B5B",
    active: "#42DA93",
    // deleted: '#FF5B5B',
    all: "#000000",
  };

  const statNameMap = {
    active: "Active",
    closed: "Closed",
    inactive: "Inactive",
    deleted: "Deleted",
    all: "Total",
  };

  const tileClickHandler = (status) => {
    navigate(`/spam-replies/${status}?limit=${""}&offset=${""}`);
    SpamAnswerDataFunction(searchGroup, status, fromDate, toDate, limit, offset);
    setSelectedElements([]);
  };

  const startDate = (date, dateString) => {
    setFromDate(dateString);
  };

  const endDate = (date, dateString) => {
    setToDate(dateString);
  };

  const search = (event) => {
    setSearchGroup(event.target.value);
  };
console.log(SpamAnswerDataSource)
  const keyPress = (event) => {
    if (event.key === "Enter") {
      const parsed = queryString.parse(location.search);
      SpamAnswerDataFunction(
        searchGroup,
        status,
        fromDate,
        toDate,
        parsed.limit,
        parsed.offset
      );
    }
  };

  const download = ({ type, all }) => {
    setSelectedElements([]);
  };

  function disabledStartDate(current) {
    return (
      (current && current.valueOf() > Date.now()) ||
      current.isSameOrAfter(toDate)
    );
  }
  function disabledEndDate(current) {
    return (
      (current && current.valueOf() > Date.now()) ||
      current.isSameOrBefore(fromDate)
    );
  }

  return loading || pageLoading ? (
    <Spinner />
  ) : (
    <div className="SQ w-full">
      <HeaderWithSearch
        name="Spam Answers"
        handleChange={search}
        keyPress={keyPress}
      />
      {/* <StatTile
        statData={SpamAnswerStatData}
        statNameMap={statNameMap}
        colorMap={colorMap}
        onClick={tileClickHandler}
        keyPress={keyPress}
      /> */}
      {selectedElements.length > 0 ? (
        <>
          <div className="mid flex justify-between items-center my-16">
            <div className="flex btns">
              <div className="downloadBtnDropdown">
                <Button popupBtn blackOutline>
                  Download All
                </Button>
                <div className="dropdownContent b-6">
                  <button
                    className="flex justify-between items-center w-full"
                    onClick={() =>
                      download({
                        type: "pdf",
                        all: true,
                      })
                    }
                  >
                    <PDFIcon />
                    Download as PDF
                  </button>
                  <button
                    className="flex justify-between items-center w-full"
                    onClick={() =>
                      download({
                        type: "csv",
                        all: true,
                      })
                    }
                  >
                    <CSVIcon />
                    Download as CSV
                  </button>
                  <button
                    className="flex justify-between items-center w-full"
                    onClick={() =>
                      download({
                        type: "xlsx",
                        all: true,
                      })
                    }
                  >
                    <XLSIcon />
                    Download as XLSX
                  </button>
                </div>
              </div>
              <div className="downloadBtnDropdown">
                <Button popupBtn blackOutline>
                  {`Download ${selectedElements.length} ${
                    selectedElements.length === 1 ? "Answer" : "Answers"
                  }`}
                </Button>
                <div className="dropdownContent b-6" style={{ width: "14rem" }}>
                  <button
                    className="flex justify-between items-center text-14 w-full px-30"
                    onClick={() => download({ type: "pdf" })}
                  >
                    <PDFIcon />
                    Download as PDF
                  </button>
                  <button
                    className="flex justify-between items-center text-14 w-full px-30"
                    onClick={() => download({ type: "csv" })}
                  >
                    <CSVIcon />
                    Download as CSV
                  </button>
                  <button
                    className="flex justify-between items-center text-14 w-full px-30"
                    onClick={() => download({ type: "xlsx" })}
                  >
                    <XLSIcon />
                    Download as XLSX
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div className="mid flex justify-between items-center my-16">
            <div className="flex btns">
              <div>
                <Button
                  popupBtn
                  blackOutline
                  style={{ marginRight: "1.5rem" }}
                  onClick={() => {
                    setSelectedElements(
                      SpamAnswerDataSource.map((item) => item.id)
                    );
                    setBlockPopup(true);
                  }}
                >
                  Close All
                </Button>
              </div>
              <div>
                <Button
                  popupBtn
                  blackOutline
                  style={{ marginRight: "1.5rem" }}
                  onClick={() => {
                    setBlockPopup(true);
                  }}
                >
                  {`Close ${selectedElements.length} ${
                    selectedElements.length === 1 ? "Answer" : "Answers"
                  }`}
                </Button>
              </div>

              <div>
                <Button
                  popupBtn
                  blackOutline
                  style={{ marginRight: "1.5rem",color:"red",borderColor:"red"}}
                  onClick={() => {
                    setSelectedElements(
                      SpamAnswerDataSource.map((item) => item.id)
                    );
                    setDeletePopup(true);
                  }}
                >
                  Delete All
                </Button>
              </div>
              <div>
                <Button
                  popupBtn
                  blackOutline
                  style={{ marginRight: "1.5rem" ,color:"red",borderColor:"red"}}
                  onClick={() => setDeletePopup(true)}
                >
                  {`Delete ${selectedElements.length} ${
                    selectedElements.length === 1 ? "Answer" : "Answers"
                  }`}
                </Button>
              </div>
              {/* {status === 'inactive' && (
                                <Button
                                    popupBtn
                                    blackOutline
                                    onClick={() => setActivatePopup(true)}
                                >
                                    {selectedElements.length === 1
                                        ? 'Activate SpamAnswer'
                                        : 'Activate SpamAnswers'}
                                </Button>
                            )} */}
              {status === "active" && (
                <Button popupBtn onClick={() => setDeactivatePopup(true)}>
                  {selectedElements.length === 1
                    ? "Close Match"
                    : "Close Selected Matches"}
                </Button>
              )}
            </div>
            <Pagination page={SpamAnswerPagination} onChange={paginationData} />
          </div>
        </>
      ) : (
        <>
          {" "}
          <div className="mid flex justify-between my-16">
            <div className="flex">
              <DatePicker
                className="datePickerStyle"
                onChange={startDate}
                disabledDate={disabledStartDate}
              />
              <div className="dash mx-14 mt-14"></div>
              <DatePicker
                className="datePickerStyle"
                onChange={endDate}
                disabledDate={disabledEndDate}
              />
            </div>
            <Pagination page={SpamAnswerPagination} onChange={paginationData} />
          </div>{" "}
        </>
      )}

      {compLoading ? (
        <Spinner top="50%" left="50%" />
      ) : (
        <div className="customTable">
          <div className="customTable-div">
            <Table
              headerLayout={headerLayout}
              columnLayout={columnLayout}
              headers={header}
              dataSource={SpamAnswerDataSource}
              dataKey={[
                {
                  name: "SelectBox",
                  render: (record) => {
                    return (
                      <div className="py-4 self-center checkbox">
                        <input
                          type="checkbox"
                          className="py-6"
                          id={record.id}
                          checked={selectedElements.includes(record.id)}
                          onChange={() => handleCheck(record.id)}
                        />
                        <label htmlFor={record.id} />
                      </div>
                    );
                  },
                },
                {
                  name: "no",
                  render: (record) => {
                    return (
                      <div className="self-center truncate py-4">
                        {record.no}
                      </div>
                    );
                  },
                },
                {
                  name: "Answer",
                  render: (record) => {
                    return (
                      <div>
                        <div
                          style={{ padding: "4px 0px 0px 0px" }}
                          className="flex items-center"
                        >
                          {record.Answer.substring(0, 100)}
                          {record.Answer.length > 100 ? "..." : ""}
                        </div>
                        {record.Answer.length > 100 && (
                          <DraggableDialog
                            title="Answer"
                            content={record.Answer}
                          />
                        )}
                      </div>
                    );
                  },
                },
                {
                  name: "asked_by",
                  render: (record) => {
                    return (
                      <div className="self-center truncate py-4">
                        {record.asked_by}
                      </div>
                    );
                  },
                },
                {
                  name: "asked_on",
                  render: (record) => {
                    return (
                      <div className="self-center truncate py-4 height-30 my-8">
                        {moment(record.created_at).format(
                          "DD/MM/YYYY, hh:mm a"
                        )}
                      </div>
                    );
                  },
                },

               
              ]}
            />
          </div>
        </div>
      )}
      <Snackbar
        open={openMessage}
        autoHideDuration={5000}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
      >
        <Alert onClose={handleClose} severity={severity}>
          {message}
        </Alert>
      </Snackbar>
      <BlockedPopup
        open={openGetError}
        setOpen={setOpenGetError}
        message={getErrorMessage}
      />
      <ConfirmPopup
        open={blockPopup}
        setOpen={setBlockPopup}
        name="Close"
        page="Answer"
        num={selectedElements.length}
        action="close"
        handleChange={() => close()}
      />
      <ConfirmPopup
        open={deletePopup}
        setOpen={setDeletePopup}
        name="Delete"
        page="Answer"
        num={selectedElements.length}
        action="Delete"
        handleChange={() => deleteSpam()}
      />
      {/* <ConfirmPopup
                open={deactivatePopup}
                setOpen={setDeactivatePopup}
                name="Close"
                page="matches"
                num={selectedElements.length}
                action="close"
                handleChange={() => closeMatch()}
            /> */}
      {/* <ConfirmPopup
                open={activatePopup}
                setOpen={setActivatePopup}
                name="Activate"
                page="SpamAnswer"
                action="activate"
                handleChange={() => activateSpamAnswer()}
            /> */}
    </div>
  );
}

const mapStateToProps = (state) => ({
  loading: state.auth.loading,
  SpamAnswerList: state.spamAnswer.SpamAnswerList,
});

export default connect(mapStateToProps)(SpamAnswers);
